import React, { useMemo, useState } from "react"
import DataTable from "../../Data/TablesData/Datatable"
import { computeColumns, getAssetClassNameFromSlug } from "../../utils"
import { useFormat } from "../../context/FormatContext"
import { useNavigate } from "react-router-dom"
import DynamicComponentRenderer from "../DynamicReactComponent/DynamicComponentRenderer"

const AssetDetailDataTable = ({
    rawData = [],
    meta = {},
    isLoading = false,
    columnConfigKey,
    datatableTitle = "Details",
    refetch,
    addActionName,
    addAction,
    actions = [],
    tableHeightId = "modal_datatable",
    onActionClick,
    dataTableHeight,
    isMultiSelect = false,
    onSelectedRowsChange,
    buttons = [],
}) => {
    const { formatDate } = useFormat()
    const APP_KEY = sessionStorage.getItem("app_key")
    const navigate = useNavigate()
    const [detailModal, setDetailModal] = useState({ key: null, open: false, data: null })

    // memoized mapping
    const updatedAssets = useMemo(() => {
        if (!rawData?.length) return []
        return rawData.map((row) => ({
            ...row,
            action_properties: meta?.action_property || [],
        }))
    }, [rawData, meta?.action_property])

    // memoized columns
    const columns = useMemo(() => {
        if (!updatedAssets?.length) return []
        return computeColumns({
            data: updatedAssets,
            meta,
            formatDate,
        })
    }, [updatedAssets, meta, formatDate])

    //  loading state

    if (isLoading) {
        return (
            <div className="e-vitals-card p-4 e-vitals-card-skeleton">
                <div className="e-skeleton-header"></div>

                <div className="e-skeleton-table">
                    {[1, 2, 3, 4, 5].map((i) => (
                        <div key={i} className="e-skeleton-row"></div>
                    ))}
                </div>
            </div>
        )
    }

    const handleActionClick = (event, { data, action_property }) => {
        const viewData = action_property?.modal_info?.view_data
        if (!viewData) return
        if (viewData?.open_in_modal) {
            setDetailModal({
                key: viewData?.modal_type_key,
                open: true,
                data: data?.values,
            })
            return
        }

        if (viewData?.open_in_new_page) {
            navigate(
                `/assets-detail/details-page?slug=${viewData?.slug}&entityid=${data?.values?.entity_id}`,
                {
                    state: { data: data.values },
                },
            )
            return
        }
    }

    return (
        <>
            <DataTable
                columns={columns}
                data={updatedAssets}
                dataTableHeight={dataTableHeight}
                isMultiSelect={isMultiSelect}
                onSelectedRowsChange={onSelectedRowsChange}
                datatableTitle={datatableTitle}
                id={tableHeightId}
                onActionClick={onActionClick ?? handleActionClick}
                addActionName={addActionName}
                addAction={addAction}
                actionProperty={updatedAssets?.[0]?.action_properties || []}
                actions={actions}
                buttons={buttons}
                columnConfigKey={columnConfigKey}
                refreshAction={() => refetch()}
                showMapViewButton={false}
                showAppLogoinTable={false}
                enableHamburger={false}
            />
            {detailModal.key && (
                <DynamicComponentRenderer
                    componentKey={detailModal.key}
                    componentName={"modal"}
                    componentProps={{
                        open: detailModal.open,
                        data: detailModal.data,
                        app_key: APP_KEY,
                        onClose: () => setDetailModal({ key: null, open: false, data: null }),
                    }}
                />
            )}
        </>
    )
}

export default AssetDetailDataTable
